import Fab from '@mui/material/Fab';
import { styled } from '@mui/material/styles';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import Zoom from '@mui/material/Zoom';
import ArrowUp from 'mdi-material-ui/ArrowUp';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';


const ScrollToTopStyled = styled('div')(({ theme }) => ({
  zIndex: 20,
  position: 'fixed',
  right: theme.spacing(10),
  bottom: theme.spacing(10),
  [theme.breakpoints.down('sm')]: {
    right: theme.spacing(4),
    bottom: theme.spacing(4),
  }
}))

const ScrollToTop = props => {
  // ** Props
  const { className, mainRef } = props
  const [ref, setRef] = useState(null)
  const { pathname } = useLocation();

  useEffect(() => {
    setRef(mainRef)
  }, [mainRef])

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const trigger = useScrollTrigger({
    target: ref ? ref.current : document.body,
    threshold: 200,
    disableHysteresis: true
  })

  const handleClick = () => {
    document.querySelector('main').scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <Zoom in={trigger}>
      <ScrollToTopStyled className={className} onClick={handleClick} role='presentation'>
        <Fab color='primary' aria-label='scroll back to top'>
          <ArrowUp />
        </Fab>
      </ScrollToTopStyled>
    </Zoom>
  )
}

export default ScrollToTop
